import { useState } from 'react';

import { TOGGLEABLE_LAYERS } from '../../../../../components/Maps/mapData/toggleableLayers';
import { Modal } from '../../../../../components/Modal/Modal';
import { useMapLayers } from '@domain/map/MapLayersContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import { useUserInfo } from '@domain/user/useUserInfo';
import catchPositions from '../../../assets/catchPositions.svg';
import spotPredictions from '../../../assets/spotPredictions.svg';
import waypoints from '../../../assets/waypoints.svg';
import {
  catchPosition,
  IModalContent,
  spotPrediction,
  waypoint,
} from '../../../constants/proModalContent';
import { ProMapLayerModal } from '../../ProMapLayerModal/ProMapLayerModal';

import { LayerButton } from './LayerButton';

export const LayerButtons = () => {
  const { isLoggedIn, isPremium } = useUserInfo();
  const { layers, toggleLayer } = useMapLayers();

  const [proModalContent, setProModalContent] = useState<IModalContent>(spotPrediction);
  const [isOpenProMapLayerModal, setIsOpenProMapLayerModal] = useState(false);

  return (
    <>
      <LayerButton
        layerName={TOGGLEABLE_LAYERS.spotPrediction.title}
        user={{ isLoggedIn, isPremium }}
        onClick={() => {
          toggleLayer('spotPrediction');
          trackEvent({
            name: 'mykiss_explore_layer_toggled',
            properties: {
              layer_type: 'spot_prediction',
              source: 'sidebar',
              state: layers.spotPrediction.isWholeLayerVisible,
            },
          });
        }}
        onProModalClick={() => {
          trackEvent({
            name: 'mykiss_explore_layer_toggled',
            properties: {
              layer_type: 'spot_prediction',
              source: 'sidebar',
              state: layers.spotPrediction.isWholeLayerVisible,
            },
          });
          setProModalContent(spotPrediction);
          setIsOpenProMapLayerModal(true);
        }}
        layerImage={spotPredictions}
        layerAlt="Toggle spot predictions"
        layerActive={layers.spotPrediction.isWholeLayerVisible}
      />
      <LayerButton
        layerName={TOGGLEABLE_LAYERS.catchPositions.title}
        user={{ isLoggedIn, isPremium }}
        onClick={() => {
          toggleLayer('catchPositions');
          trackEvent({
            name: 'mykiss_explore_layer_toggled',
            properties: {
              layer_type: 'catch_location',
              source: 'sidebar',
              state: layers.catchPositions.isWholeLayerVisible,
            },
          });
        }}
        onProModalClick={() => {
          trackEvent({
            name: 'mykiss_explore_layer_toggled',
            properties: {
              layer_type: 'catch_location',
              source: 'sidebar',
              state: layers.catchPositions.isWholeLayerVisible,
            },
          });
          setProModalContent(catchPosition);
          setIsOpenProMapLayerModal(true);
        }}
        layerImage={catchPositions}
        layerAlt="Toggle logged catches"
        layerActive={layers.catchPositions.isWholeLayerVisible}
      />
      <LayerButton
        layerName={TOGGLEABLE_LAYERS.waypoints.title}
        user={{ isLoggedIn, isPremium }}
        onClick={() => {
          toggleLayer('waypoints');
          trackEvent({
            name: 'mykiss_explore_layer_toggled',
            properties: {
              layer_type: 'waypoints',
              source: 'sidebar',
              state: layers.waypoints.isWholeLayerVisible,
            },
          });
        }}
        onProModalClick={() => {
          trackEvent({
            name: 'mykiss_explore_layer_toggled',
            properties: {
              layer_type: 'waypoints',
              source: 'sidebar',
              state: layers.waypoints.isWholeLayerVisible,
            },
          });
          setProModalContent(waypoint);
          setIsOpenProMapLayerModal(true);
        }}
        layerImage={waypoints}
        layerAlt="Toggle your waypoints"
        layerActive={layers.waypoints.isWholeLayerVisible}
      />
      {isOpenProMapLayerModal && (
        <Modal
          isOpen
          onClose={() => {
            setIsOpenProMapLayerModal(false);
          }}
          size="xl"
          style={{ minHeight: '580px', maxWidth: '1280px' }}
        >
          <ProMapLayerModal {...proModalContent} />
        </Modal>
      )}
    </>
  );
};
